import Http from '../../network/Http'
import AdminUserSimple from './AdminUserSimple'
import {ApiResponse} from '../../network/response/ApiResponse'
import {ContentType} from '../../network/Constants';

export interface ConditionForGetReservableUsersForManagerReservation {
    condominiumCd?: string
    familyName?: string
    firstName?: string
    familyNameKana?: string
    firstNameKana?: string
    withinTerm?: {
        startDate: string
        endDate: string
    }
}

export default class AdminUserRepository {
    http: Http

    constructor(http: Http) {
        this.http = http
    }

    async getReservableUsersForManagerReservation(
        condition: ConditionForGetReservableUsersForManagerReservation,
    ): Promise<AdminUserSimple[]> {

        let startDateWithinTerm = null;
        let endDateWithinTerm = null;
        if( condition.withinTerm !== undefined )
        {
            startDateWithinTerm = condition.withinTerm.startDate
            endDateWithinTerm = condition.withinTerm.endDate
        }
        const response: ApiResponse<AdminUserSimple> =
            await this.http.post(`/api/admin/admin-users-for-reservation`,
                {
                    condominiumCd: condition.condominiumCd,
                    familyName: condition.familyName === undefined ? null : condition.familyName,
                    firstName: condition.firstName === undefined ? null : condition.firstName,
                    familyNameKana: condition.familyNameKana === undefined ? null : condition.familyNameKana,
                    firstNameKana: condition.firstNameKana === undefined ? null : condition.firstNameKana,
                    startDateWithinTerm: startDateWithinTerm,
                    endDateWithinTerm: endDateWithinTerm
                },
                ContentType.JSON)
        const apiResponse: ApiResponse<AdminUserSimple[]> =
            ApiResponse.fromArray(response, AdminUserSimple.from)
        return apiResponse.details
    }
}
